module.exports = __webpack_public_path__ + "media/site_templates/www.localfencingcompanies.com.au/images/feature_2-9080c17e7df3379d9ccb8f0b3fef4974.jpeg";